module.exports = __webpack_public_path__ + "img/flowers.16179c5b.svg";